<template>
    <div class="d-flex align-center gst-clamp-copy">
        <ClampToggle
            class="gst-clamp"
            :text="value" />
        <CopyToClipboard :value="value" />
    </div>
</template>
<script>
import ClampToggle from '@components/clamp/ClampToggle.vue';
import CopyToClipboard from '@/components/CopyToClipboard.vue';

export default {
    name: 'CopyToClipboardAndToggleCellRenderer',
    components: {
        ClampToggle,
        CopyToClipboard,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        value() {
            return this.params.value;
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';

.gst-clamp-copy {
    padding-top: theme-spacing(2);

    .gst-clamp {
        div {
            width: 90px !important;
            text-overflow: ellipsis;
            text-wrap: wrap;
            line-height: line-height('2xl');
        }
    }
}
</style>
